import React from "react";
import Popup from "../../../../components/Popup/Popup";
import PopupContent from "../../../../components/Popup/PopupContent";
import Container from "../../../../components/Container";
import Body from "../../components/Body";
import About from '../../../Fireboard/components/About';
import NetworkLogs from '../../../Fireboard/components/NetworkLogs';
import { version } from '../../../../../package.json';

const Desktop = (props) => {
  const {
    closePopup,
    popup,
    infoMetaData,
    networkLogs,
    deviceName,
  } = props || {};

  const getPopupStyle = () => {
    let popupStyle = { width: "40.41vw" };
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (popup && popup.type === 'about') {
      popupStyle = { width: '34vw' };
    } else if (popup && popup.type === 'networkLogs') {
      popupStyle = { width: '80vw' };
    }
    return popupStyle;
  };

  const getPopupContent = () => {
    if (!popup) return;

    switch (popup.type) {
      case 'about': {
        return (
          <About
            storeName={infoMetaData?.storeName}
            buildVersion={version}
            isDevEnvironment={infoMetaData?.isDevEnvironment}
            supportNumber={infoMetaData?.supportNumber}
            onClose={closePopup}
            baseUrl={infoMetaData?.baseUrl}
            rnDevEnv={infoMetaData?.rnDevEnv}
            deviceName={deviceName}
          />
        );
      }
      case 'networkLogs': {
        return <NetworkLogs onClose={closePopup} networkLogs={networkLogs} />;
      }
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  return (
    <Container>
      <Popup
        visible={!!popup}
        popupStyle={getPopupStyle()}
        closePopup={closePopup}
      >
        {getPopupContent()}
      </Popup>
      <Body {...props} />
    </Container>
  );
};

export default Desktop;